import { Components } from '@mui/material'

export function OverridedAppBar(): Components {
  return {
    MuiAppBar: {
      styleOverrides: {
        root: {
          '& .MuiToolbar-root': {
            minHeight: 50,
          },
          'backgroundColor': 'white',
        },
      },
    },
  }
}
